var map = {
	"./diag-01.png": 60374,
	"./diag-01_en.png": 6373,
	"./diag-02.png": 40945,
	"./diag-03.png": 84357,
	"./diag-04.png": 20926,
	"./diag-05.png": 9431,
	"./diag-06.png": 49029,
	"./diag-06_en.png": 52137,
	"./diag-bg-01.png": 56902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43221;